import React from 'react';
import Link from 'gatsby-link';
import './_address-block.scss';

import Empfang from '../../resources/images/empfang.jpg';
import Empfang2x from '../../resources/images/empfang@2x.jpg'

const AddressBlock = ({children}) => (
    <section className="contact-block--wrapper">
        <div className="contact-block--address">
            <h1 className="dark large">Radiologie Bregenz</h1>
            <address>
                Römerstraße 9 - 13, 6900 Bregenz <br/>
                Tel. <a href="tel:0043557453500" className="plain light">+43 (0)5574 53500</a><br/>
                Fax: +43 (0)5574 53500 - 4 <br/>
                <a href="mailto:office@radbregenz.at">office@radbregenz.at</a>
            </address>
            <p className="zeiten">
                Öffnungszeiten MRT:<br/>
                Mo - Do: 07:30 - 12:00 und 13:30 - 17:00<br/>
                Fr + Sa: 08:00 - 12:00
            </p>
            <p className="zeiten">
                Öffnungszeiten Röntgen:<br/>
                Mo - Do: 08:00 - 16:00<br/>
                Fr: 08:00 - 12:00
            </p>
            <Link to="/impressum" className="small featured address-link">Impressum</Link>
        </div>
        <div className="contact-block--img">
            <img src={Empfang} />
        </div>
    </section>
)

export default AddressBlock



// WEBPACK FOOTER //
// ./src/components/address/index.jsx